import { useApp } from '../hooks/AppProvider.tsx';
import { Navigate } from 'react-router-dom';
import GeneralError from '../views/error/GeneralError.tsx';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type RedirectToRaceUrlProps = {
  targetPath: string;
};

const RedirectToDefaultRaceUrl = ({ targetPath }: RedirectToRaceUrlProps): ReactElement | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.redirects' });
  const [{ event }] = useApp();
  const [firstRace] = event?.subEvents ?? [];

  if (!firstRace) {
    return <GeneralError title={t('error_title')} message={''} />;
  }

  return <Navigate to={`../race/${firstRace.id}/${targetPath}`} />;
};

export default RedirectToDefaultRaceUrl;
